import React, { useState, useEffect, useRef } from 'react'
import Filter from '../../components/Filter'
import {
	Row,
	Col,
	Image,
	FormControl,
	Button,
	Modal,
	Badge
} from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
	faFileDownload,
	faChevronRight,
	faChevronLeft,
	faEye,
	faArrowRight
} from '@fortawesome/free-solid-svg-icons'
import styles from './Jobseekers.module.scss'
import EButton from '../../components/bootstrap-extended/EButton'
import 'react-day-picker/lib/style.css'
import ReactPaginate from 'react-paginate'
import moment from 'moment'
import { CSVLink } from 'react-csv'
import { useLocation } from 'react-router-dom'
import axios from 'axios'
import ProfileDownload from '../../components/jobSeekers/ProfileDownload'
import DayPickerInput from 'react-day-picker/DayPickerInput'
import dayjs from 'dayjs'

interface DateCSSProps {
	classNames: {
		overlayWrapper: string,
		overlay: string
	},
	children: React.ReactNode
}

const CustomOverlay: React.FC<DateCSSProps> = ({ classNames, children, ...props }) => {
	return (
		<div
			className={classNames.overlayWrapper}
			style={{ marginLeft: -85 }}
			{...props}
		>
			<div className={classNames.overlay}>
				{children}
			</div>
		</div>
	)
}

interface DataProps {
  id: number
  name: string
  age: number
  avatar: string
  gender: string
  nationality: string
  location: string
  numberOfApplications: number
	kiosk: string
	contact: string
}

function useQuery() {
	const { search } = useLocation()
	return React.useMemo(() => new URLSearchParams(search), [search])
}

const Jobseekers = () => {
	const csvLink = useRef<any | null>(null)
	const query = useQuery()
  
	const [applicants, setApplicants] = useState<Array<DataProps>|null>([])
	const [applicantDetails, setApplicantDetails] = useState<any>(null)

	const [startDate, setStartDate] = useState<string>('')
	const [endDate, setEndDate] = useState<string>('')
	const [filterPage, setFilterPage] = useState('')

	const [dataExport, setDataExport] = useState<any[]>([])
	const [dataAggregate, setDataAggregate] = useState(0)

	const [pageNo, setPageNo] = useState('')
	const [toPage, setToPage] = useState<number>(0)
	const [isLoading, setIsLoading] = useState(true)

	const [showProfile, setShowProfile] = useState(false)

	// pagination
	const [pageCount, setPageCount] = useState(0)
	const [itemOffset, setItemOffset] = useState(0)
	const itemsPerPage = 10

	const exportHeader = [
		{ label: 'Applicant Name', key: 'name' },
		{ label: 'NRIC', key: 'nric' },
		{ label: 'Contact', key: 'contact' },
		{ label: 'DOB', key: 'dateOfBirth' },
		{ label: 'Age', key: 'age' },
		{ label: 'Gender', key: 'gender' },
		{ label: 'Nationality', key: 'nationality' },
		{ label: 'Location', key: 'location' },
		{ label: 'Postal Code', key: 'postalCode' },
		{ label: 'Total job applied', key: 'numberOfApplications' },
	]

	const page = query.get('page')
	const startDateQuery = query.get('startDate')
	const endDateQuery = query.get('endDate')
	const filters = {
		page: page !== null && parseInt(page) ? page : 1,
		startDate: startDateQuery !== null && startDateQuery ? startDateQuery : '',
		endDate: endDateQuery !== null && endDateQuery ? endDateQuery : '',
	}

	const handlePageClick = (event: { selected: number }) => {
		window.location.href = getPaginationLink((event.selected + 1).toString())
	}

	const getPaginationLink = (page: string): string => {
		return `/jobseekers?page=${page}&startDate=${filters.startDate}&endDate=${filters.endDate}`
	}

	useEffect(() => {
		const getApplicants = async () => {
			try {
				const res = await axios.get(process.env.REACT_APP_ROUTE_GET_APPLICANT as string + `?page=${filters.page}&startDate=${filters.startDate}&endDate=${filters.endDate}`)
				setApplicants(res.data.applicants)
				setIsLoading(false)
				setPageCount(Math.ceil(res.data.applicantAggregate / itemsPerPage))
				setPageNo(filters.page.toString())
				setStartDate(filters.startDate)
				setEndDate(filters.endDate)
				setDataAggregate(res.data.applicantAggregate)
			} catch (err) {
				console.log(err)
			}
		}
		getApplicants()
	}, [])

	useEffect(() => {
		if (dataExport && csvLink && csvLink.current && csvLink.current.link) {
			setTimeout(() => {
				csvLink.current.link.click()
				setDataExport([])
			})
		}
	}, [dataExport])

	const getAllApplicants = async () => {
		try {
			const res = await axios.get(process.env.REACT_APP_ROUTE_GET_APPLICANT as string + `?pageSize=${dataAggregate}`)
			setDataExport(res.data.applicants)
		} catch (err) {
			console.log(err)
		}
	}

	useEffect(() => {
		const toNum = () => {
			if(pageNo===''){
				setItemOffset(0)
				setToPage(0)
			}else{
				const temp = parseInt(pageNo)
				setItemOffset(temp-1)
				setToPage(temp-1)
			}
		}
		toNum()
	}, [pageNo])


	const numbersOnly = (val:string) => {
		const numsCheck = new RegExp('^[0-9]{1,6}$')//6 digits only
		if(numsCheck.test(val) || val === ''){
			setFilterPage(val)   
		}
		if(parseInt(val) > pageCount) {
			setFilterPage(pageCount.toString())
		}
	}

	const submitPageNumber = () => {
		window.location.href = `/jobseekers?page=${filterPage}&startDate=${filters.startDate}&endDate=${filters.endDate}`
	}
  
	const getStatus = (status: string) => {
		switch (status) {
		case 'SUCCESSFUL':
			return <span className={`badge ${styles.customBadge}`} style={{ backgroundColor: '#EBFFF1', border: '1px solid #2BCB5C', color: '#2BCB5C' }}>{status}</span>

		case 'UNSUCCESSFUL':
			return <span className={`badge ${styles.customBadge}`} style={{ backgroundColor: '#FFF2F2', border: '1px solid #FE6565', color: '#FE6565' }}>{status}</span>

		case 'PENDING':
			return <span className={`badge ${styles.customBadge}`} style={{ backgroundColor: '#FFF3ED', border: '1px solid #FE9465', color: '#FE9465' }}>{status}</span>

		case 'VIEWED':
			return <span className={`badge ${styles.customBadge}`} style={{ backgroundColor: '#F3EFFF', border: '1px solid #8E6CFA', color: '#8E6CFA' }}>{status}</span>

		case 'SHORTLISTED':
			// return <span className={`badge ${styles.customBadge}`} style={{ backgroundColor: '#E5F5FF', border: '1px solid #1CA8FF', color: '#1CA8FF' }}>{status}</span>
			return <span className={`badge ${styles.customBadge}`} style={{ backgroundColor: '#EBFFF1', border: '1px solid #2BCB5C', color: '#2BCB5C' }}>CONTACTUNLOCKED</span>

		case 'CONTACTUNLOCKED':
			return <span className={`badge ${styles.customBadge}`} style={{ backgroundColor: '#EBFFF1', border: '1px solid #2BCB5C', color: '#2BCB5C' }}>{status}</span>
		}
	}
  
	const viewApplicantDetails = async (id: number) => {
		try {
			const res = await axios.get(process.env.REACT_APP_ROUTE_GET_APPLICANT as string + `/${id}`)
			setApplicantDetails(res.data.applicant)
			setShowProfile(true)
		} catch (err) {
			console.log(err)
		}
	}

	const handleDateChange = (startDateSelected: string, endDateSelected: string): void => {
		window.location.href = `/jobseekers?page=1&startDate=${startDateSelected}&endDate=${endDateSelected}`
	}

	return (
		<div>
			<Row>
				<Col>
					<Filter/>
				</Col>
			</Row>
			<Row className={styles.searchCompRow}>
				<Col style={{ display: 'flex', flexFlow: 'row wrap' }}>
					<div className={styles.dateCont}>
						<div className={styles.filterDateDiv}>
							<Image src='/img/cal.png' alt='search' width='15' height='15' />
							<DayPickerInput
								formatDate={(str) => dayjs(str).format('YYYY-MM-DD')}
								onDayChange={(day) => handleDateChange(dayjs(day).format('YYYY-MM-DD'), endDate)}
								overlayComponent={CustomOverlay}
								placeholder={'Start Date'}
								value={startDate}
							/>
						</div>
					</div>
					<div className={`d-none d-sm-block ${styles.dateArrow}`}>
						<FontAwesomeIcon icon={faArrowRight} size="xs" color="#9FB1C7" />
					</div>
					<div className={styles.dateCont}>
						<div className={styles.filterDateDiv}>
							<Image src='/img/cal.png' alt='search' width='15' height='15' />
							<DayPickerInput
								formatDate={(str) => dayjs(str).format('YYYY-MM-DD')}
								onDayChange={(day) => handleDateChange(startDate, dayjs(day).format('YYYY-MM-DD'))}
								overlayComponent={CustomOverlay}
								placeholder={'End Date'}
								value={endDate}
							/>
						</div>
					</div>
					<div className={styles.vertical__align}>
						<Button
							variant='link'
							onClick={() => {
								handleDateChange('', '')
							}}
						>
							Clear
						</Button>
					</div>
				</Col>
				<Col lg={2} md={2}>
					<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
						<div onClick={getAllApplicants}>
							<EButton
								buttonText='Export'
								icon={<FontAwesomeIcon icon={faFileDownload} />} isSubmitting={false} className={styles.cusBtn}
							/>
						</div>
						{dataExport.length > 0 ?
							<CSVLink
								data={dataExport}
								headers={exportHeader}
								filename={'Jobs.csv'}
								ref={csvLink}
							/>
							: undefined
						}
					</div>
				</Col>
			</Row>
			{/* table */}
			{/* header */}
			<div style={{overflowX: 'auto'}}>
				<table style={{width: '100%'}}>
					<div className={styles.tableHeader}>
						<Row className={styles.mobileViewSlideTable}>
							{['Applicant name', 'Total job applied'].map((val,index)=>(
								<Col key={index} xs={6} sm={index === 0 ? 8 : 2} className={index !== 0 ? 'text-center' : ''}>
									<h6>{val}</h6>
								</Col>
							))}		
						</Row>
					</div>
					{/* items */}
					<div>
						{isLoading ? (
							<div className='text-center mt-3'>
								<p>Loading</p>
							</div>
						) : (
							applicants && applicants.map((applicant, index) => {
								return (
									<div 
										key={index} 
										className={styles.tableBody} 
										onClick={() => 
											viewApplicantDetails(applicant.id)
										} 
									>								
										<Row className={styles.mobileViewSlideTable}>
											<Col xs={6} sm={8}>
												<Row className='align-items-center'>
													<Col md={2} className='text-xs-start text-sm-center'>
														<Image 
															roundedCircle 
															src={applicant.avatar !== null ? 
																applicant.avatar : 
																'https://dashboard.findjobs.com.sg/static/media/default_boy_avatar.dc83eae1.svg'
															} 
															style={{ width: '70px', height: '70px', margin: '16px'}} 
														/>
													</Col>  
													<Col>
														<div className='p-3 p-sm-0'>
															<h5>{applicant.name}</h5>
															<small style={{ display: 'block' }}>
																{applicant.age !== null && <span>{applicant.age} years old</span>}
																{applicant.gender !== null && <span> | {applicant.gender}</span>}
																{applicant.nationality !== null && <span> | {applicant.nationality}</span>}
																{applicant.location !== null && <span> | Lives in {applicant.location}</span>}
															</small>
															<Badge bg='secondary'>{applicant.kiosk}</Badge>
														</div>
													</Col>
												</Row>
											</Col>
											<Col xs={6} sm={2} className='d-flex align-items-center justify-content-center'><p>{applicant.numberOfApplications}</p></Col>
											<Col xs={3} sm={2} className='d-none d-sm-flex align-items-center justify-content-center'>
												<Button 
													className={styles.filterBtn} 
													onClick={() => 
														viewApplicantDetails(applicant.id)
													} 
												>
													<FontAwesomeIcon icon={faEye}/>
													<span className='ps-2'>Details</span>
												</Button>
											</Col>
										</Row>
									</div>
								)
							})
						)}
					</div>
				</table>
			</div>

			<Row style={{ marginTop: '20px' }}>
				<Col/>
				<Col>
					<ReactPaginate
						containerClassName={styles.pagination}
						previousClassName="page-item"
						nextLinkClassName="page-link"
						// activeClassName="active"
						activeLinkClassName={styles.paginationActive}
						pageClassName="page-item"
						pageLinkClassName="page-link"
						previousLinkClassName="page-link"
						nextClassName="page-item"
						breakLinkClassName="page-link"
						breakClassName="page-item"
						previousLabel={<FontAwesomeIcon icon={faChevronLeft} />}
						pageCount={pageCount}
						onPageChange={handlePageClick}
						nextLabel={<FontAwesomeIcon icon={faChevronRight} />}
						pageRangeDisplayed={3}
						marginPagesDisplayed={3}
						breakLabel="..."
						forcePage={toPage}
					// renderOnZeroPageCount={null}
					/>
				</Col>
				<Col style={{display:'flex', justifyContent:'flex-end'}}>
					<span style={{fontSize: '14px', color:'#5B7493', paddingTop:'5px'}}>Go to page</span>
					<FormControl
						style={{width: '15%', display: 'inline-block', margin: '0 10px', height: '35px'}}
						onChange={e => {
							numbersOnly(e.target.value)
						}}
						value={filterPage}
					/>
					<Button onClick={submitPageNumber} variant='primary' className={styles.cusBtn}>
            Go
					</Button>
				</Col>
			</Row>

			<Modal show={showProfile} size='lg' onHide={() => { setShowProfile(false) }}>
				<Modal.Header closeButton className='border-0'/>
				<Modal.Body className='px-5 pt-0'>
					{applicantDetails && (
						<>
							<Row>
								<Col xs={4} sm={2} className='text-center'>
									<Image 
										roundedCircle 
										src={applicantDetails.avatar !== null ? 
											applicantDetails.avatar : 
											'https://dashboard.findjobs.com.sg/static/media/default_boy_avatar.dc83eae1.svg'
										}
										style={{ width: '70px', height: '70px', marginTop: '10px', marginBottom: '10px' }} />
								</Col>
								<Col xs={8} className='d-flex align-items-center'>
									<div>
										<h5>{applicantDetails.name}</h5>
										<small style={{ display: 'block' }}>
											{applicantDetails.age !== null && <span>{applicantDetails.age} years old</span>}
											{applicantDetails.gender !== null && <span> | {applicantDetails.gender}</span>}
											{applicantDetails.nationality !== null && <span> | {applicantDetails.nationality}</span>}
											{applicantDetails.locationOther !== null && <span> | Lives in {applicantDetails.locationOther}</span>}
										</small>
										<Badge bg='secondary'>{applicantDetails.kiosk}</Badge>
									</div>
								</Col>
							</Row>
							<br />
							<Row>
								<Col xs={6} sm={3}>
									<p>
										<span>NRIC</span> <br />
										<span>Date of Birth</span> <br />
										<span>Race</span> <br />
										<span>Contact</span> <br />
										<span>Street Address</span> <br />
									</p>
								</Col>
								<Col>
									<p>
										<span>{applicantDetails.nric ? applicantDetails.nric : '-'}</span> <br />
										<span>{applicantDetails.dateOfBirth ? applicantDetails.dateOfBirth : '-'}</span> <br />
										<span>{applicantDetails.race ? applicantDetails.race : '-'}</span> <br />
										<span>{applicantDetails.contact ? applicantDetails.contact : '-'}</span> <br />
										<span>{applicantDetails.streetAddress ? applicantDetails.streetAddress : '-'}</span> <br />
									</p>
								</Col>
							</Row>
							<ProfileDownload applicant={applicantDetails} filename={`${applicantDetails.name}-${Date.now()}`}/>
							<hr />
							<p><strong>Job applied</strong></p>
							<div className='overflow-scroll' style={{ height: '400px' }}>
								{applicantDetails.applications.map((job: any, i: number) => {
									return (
										<Row key={i}>
											<Col>
												<p>{moment(job.appliedOn).format('DD MMM YYYY, h:mm a')}</p>
											</Col>
											<Col>
												<p><strong>{job.title}</strong></p>
											</Col>
											<Col className='text-end'>
												{getStatus(job.status)}
											</Col>
										</Row>
									)
								})}
							</div>
						</>
					)}
				</Modal.Body>
			</Modal>
		</div>
	)
}

export default Jobseekers